import type {
  LockPreview,
  LockPreviewRow,
} from '@sportninja/common/services/teamBalance'
import { balanceLabel } from './balanceI18n'

/**
 * The name of one payment in the Send Invoice preview.
 *
 * Sep 23 — a team official's line is ONE charge, tax on top, due the day it is
 * sent (`schedule_shape: one_time`), so its single row reads "One Payment" rather
 * than "Installment 1" of a plan it is not on.
 */
export const lockPreviewRowLabel = (
  row: Pick<LockPreviewRow, 'type' | 'installment_number'>,
  scheduleShape?: LockPreview['schedule_shape']
): string => {
  if (scheduleShape === 'one_time') {
    return balanceLabel('common:balancePreviewOnePayment')
  }
  if (row.type === 'deposit') {
    return balanceLabel('common:balancePreviewDeposit')
  }

  return balanceLabel('common:balancePreviewInstallment', {
    number: row.installment_number,
  })
}
